/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumBenutzer: {
    name: 'big-medium-benutzer';
    data: string;
} = {
    name: 'big-medium-benutzer',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M64 62.46a29.73 29.73 0 1 0-29.73-29.73A29.77 29.77 0 0 0 64 62.46M64 13a19.73 19.73 0 1 1-19.73 19.73A19.75 19.75 0 0 1 64 13m9.78 54H54.22A47.27 47.27 0 0 0 7 114.22V116a9 9 0 0 0 9 9h78a5 5 0 0 0 0-10H17v-.78A37.27 37.27 0 0 1 54.22 77h19.56A37.27 37.27 0 0 1 111 114.22V120a5 5 0 0 0 10 0v-5.78A47.27 47.27 0 0 0 73.78 67"/></svg>`,
};
